export default {
  // ========== Header ==========
  pda: "PDA",
  suitcase: "Instructional",
  didactic: "Kit",
  classroomDidacticPlanSynthesis: "Classroom Didactic Plan Synthesis",

  // ========== Section 1: General Information ==========
  generalInformation: "General Information",
  careers: "Career(s)",
  prerequisites: "Prerequisites",

  // ========== Section 2: Subject Description ==========
  subjectDescription: "Subject Description",
  noDescriptionForEntity: "No description for {entity}.",
  noEntityForSubject: "There are no {entity1} for {entity2}.",

  // ========== Competences and Learning Outcomes ==========
  learningResults: "Learning Outcomes",
  learningResult: "Learning Outcome",
  achievementIndicator: "Achievement Indicator",

  // ========== Section 3: Learning Route Synthesis ==========
  learningRouteSynthesis: "Learning Route Synthesis",
  learningExperience: "Learning Experience",
  activitiesAndEvaluations: "Activities and Evaluations",
  learningEnvironments: "Learning Environments",
  hoursCount: "No. Hours",
  activityAssociatedToVcm: "Activity Associated to VCM",
  total: "Total",
  noLearningRouteSynthesis: "There is no {entity}.",

  // ========== Section 4: Evaluations ==========
  evaluations: "Evaluations",
  evaluation: "Evaluation",
  evaluativeSituation: "Evaluative Situation",
  partialEvaluationWeight: "Partial Evaluation Weight (%)",
  finalWeightingEvaluations: "Final Weighting Evaluations",
  noPartialEvaluations: "There are no Partial Evaluations.",

  // ========== Section 5: Learning Experiences ==========
  learningExperiences: "Learning Experiences",
  activities: "Activities",
  learningResources: "Learning Resources",
  educationalTechnology: "Educational Technology",
  learningEnvironment: "Learning Environment",
  noActivitiesInEntity: "There are no activities in this {entity}.",
  evaluationType: "Evaluation Type",
  noEvaluationsInEntity: "There are no evaluations in this {entity}.",
  withoutDescription: "No Description",
}
